import { resolveImageAlt } from '@eliadmin/core/src/utils/image-alt-utils';
import type { CategoriesEntity } from '@eliadmin/core/src/api/general/types/general-layout-types';
import type { CategorySliderClassName } from '@eliadmin/core/src/components/header/category-slider';
import { cn } from '@eliadmin/core/src/utils/style-utils';
import Image from '@eliadmin/core/src/components/image/image-wrapped';
import Link from '@eliadmin/core/src/components/link';
import { useState } from 'react';

type CategorySliderChildCategoryProps = {
  category: CategoriesEntity;
  childCategory: CategoriesEntity;
  className?: CategorySliderClassName;
};

export const CategorySliderChildCategory = ({
  category,
  childCategory,
  className,
}: CategorySliderChildCategoryProps) => {
  const [subChildCategoryDisplayCount, setSubChildCategoryDisplayCount] = useState(4);

  return (
    <li
      key={`${childCategory.name}-${childCategory.slug}`}
      className={cn(
        'text-md grid grid-cols-5 font-medium text-foreground',
        'ea-category__hover-card-list-item',
      )}
    >
      <div className="col-span-1">
        {childCategory?.icon?.url && (
          <Image
            alt={resolveImageAlt(childCategory?.icon, undefined)}
            src={childCategory?.icon?.url}
            width={160}
            height={160}
            style={{
              width: 60,
              height: 60,
              objectFit: 'contain',
              filter: childCategory.icon.url.endsWith('.svg')
                ? 'brightness(0) saturate(100%) invert(79%) sepia(51%) saturate(5021%) hue-rotate(348deg) brightness(105%) contrast(90%)'
                : 'none',
            }}
          />
          // ) : (
          //   <LuStar size={24} className="h-10 w-10 text-accent" />
        )}
      </div>
      <div className="col-span-4 flex flex-col gap-2">
        <Link prefetchOnHover
          href={childCategory.slug}
          className={cn(
            'text-md font-bold hover:underline',
            'ea-category-slider__hover-card-link',
            className?.hoverCardLink,
          )}
        >
          {childCategory.name}
        </Link>
        <div className="flex flex-col">
          {childCategory.childs?.map(
            (subChildCategory, index) =>
              index < subChildCategoryDisplayCount && (
                <Link prefetchOnHover
                  key={index}
                  href={subChildCategory.slug}
                  className={cn(
                    'col-span-3 text-sm font-medium hover:underline',
                    'ea-category-slider__hover-card-link',
                    className?.hoverCardLink,
                  )}
                >
                  {subChildCategory.name}
                </Link>
              ),
          )}
          {!!childCategory.childs?.length &&
            subChildCategoryDisplayCount < childCategory.childs?.length && (
              <p
                onClick={() => setSubChildCategoryDisplayCount(prev => prev + 5)}
                className="cursor-pointer text-sm text-primary hover:underline"
              >{`+${
                childCategory.childs?.length - subChildCategoryDisplayCount > 5
                  ? 5
                  : childCategory.childs?.length - subChildCategoryDisplayCount
              } ďalších`}</p>
            )}
        </div>
      </div>
    </li>
  );
};
